import { axiosMeedioClient } from './client';
import { MeetingResponse, UpdateMeetingRequest } from './types';

export const updateMeeting = async (meetingId: string, payload: UpdateMeetingRequest) => {
  const { data } = await axiosMeedioClient.patch<MeetingResponse>(`/meetings/${meetingId}`, payload);
  return data;
};
